import { defineProperty as _defineProperty } from '../../../_virtual/_rollupPluginBabelHelpers.js';

var TOGGLE_SIZES = {
  REGULAR: 'regular',
  SMALL: 'small'
};
var INDICATOR_DIMENSIONS = _defineProperty(_defineProperty({}, TOGGLE_SIZES.REGULAR, "\n    height: 1.5rem;\n    width: 2.375rem;\n    min-width: 2.375rem;\n  "), TOGGLE_SIZES.SMALL, "\n    height: 1rem;\n    width: 1.625rem;\n    min-width: 1.625rem;\n  ");
var CIRCLE_DIMENSIONS = _defineProperty(_defineProperty({}, TOGGLE_SIZES.REGULAR, "\n    height: 1.25rem;\n    width: 1.25rem;\n  "), TOGGLE_SIZES.SMALL, "\n    height: 0.75rem;\n    width: 0.75rem;\n  ");
var CIRCLE_POSITIONS = _defineProperty(_defineProperty({}, TOGGLE_SIZES.REGULAR, function (checked, theme) {
  return "\n    left: ".concat(checked ? theme.sizing.medium : theme.sizing.xtiny, ";\n  ");
}), TOGGLE_SIZES.SMALL, function (checked, theme) {
  return "\n    left: ".concat(checked ? theme.sizing.regular : theme.sizing.xtiny, ";\n  ");
});

export { CIRCLE_DIMENSIONS, CIRCLE_POSITIONS, INDICATOR_DIMENSIONS, TOGGLE_SIZES };
//# sourceMappingURL=Toggle.constants.js.map
